import React from 'react';
import Header from '../components/Header';
import { connect } from 'react-redux';
import { setOrganization, setScheduleDeep, setTSes, setTSesList, setSchedule } from '../actions';

const mapStateToProps = (state) => ({
    days: state.days,
    organizationsList: state.organizationsList,
    organization: state.organization,
    organizationCode: state.organizationCode,
    tSesList: state.tSesList,
    tSes: state.tSes,
    organizationSwitcher: state.organizationSwitcher,
    tSesSwitcher: state.tSesSwitcher,
});

const mapDispatchToProps = (dispatch) => ({
    setOrganization(data) {
        dispatch(setOrganization(data))
    },
    setScheduleDeep(days) {
        dispatch(setScheduleDeep(days))
    },
    setTSes(tSes) {
        dispatch(setTSes(tSes))
    },
    setTSesList(list) {
        dispatch(setTSesList(list))
    },
    setSchedule(data) {
        dispatch(setSchedule(data))
    },
});

const HeaderContainer = ({days, organizationsList, organization, organizationCode, organizationSwitcher, tSesSwitcher, setOrganization, setScheduleDeep, tSesList, tSes, setTSes, setTSesList, setSchedule}) => {
    return(
        <Header
            days={days}
            organizationsList={organizationsList}
            organization={organization}
            organizationCode={organizationCode}
            tSesList={tSesList}
            tSes={tSes}
            organizationSwitcher={organizationSwitcher}
            tSesSwitcher={tSesSwitcher}
            setOrganization={setOrganization}
            setScheduleDeep={setScheduleDeep}
            setTSes={setTSes}
            setTSesList={setTSesList}
            setSchedule={setSchedule}
        />
    )
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderContainer)